"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _video = _interopRequireDefault(require("video.js"));


// import { timeStamp } from 'console';
var Plugin = _video.default.getPlugin('plugin'); // Default options for the plugin.


var defaults = {};
var ingestUrl = "http://35.184.21.197:2096/ingest";
/**
 * An advanced Video.js plugin. For more information on the API
 *
 * See: https://blog.videojs.com/feature-spotlight-advanced-plugins/
 */

var ThetaVideoMetrics = /*#__PURE__*/function (_Plugin) {
  (0, _inheritsLoose2.default)(ThetaVideoMetrics, _Plugin);

  /**
   * Create a ThetaVideoMetrics plugin instance.
   *
   * @param  {Player} player
   *         A Video.js Player instance.
   *
   * @param  {Object} [options]
   *         An optional options object.
   *
   *         While not a core part of the Video.js plugin architecture, a
   *         second argument of options is a convenient way to accept inputs
   *         from your plugin's caller.
   */
  function ThetaVideoMetrics(player, options) {
    var _this;

    // the parent class will add player under this.player
    _this = _Plugin.call(this, player) || this;
    var playbackStatus = 0,
        loadStatus = 0;
    var firstPlayTime = 0;
    var closeTime = 0;
    var waiting = false,
        waitingStartTime,
        rebufferCount = 0,
        rebufferTime = 0,
        rebufferPercentage = 0;
    _this.options = _video.default.mergeOptions(defaults, options);

    _this.ingestMetricsPlaybackSuccess = function (payload) {
      console.log("jlog11", payload);
      fetch(ingestUrl + '/playback', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      }).then(function (response) {
        return response.json();
      }).then(function (data) {
        return console.log("jlog12", data);
      });
    };

    _this.ingestRebufferingData = function (payload) {
      console.log("jlog13", payload);
      fetch(ingestUrl + '/rebuffer', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      }).then(function (response) {
        return response.json();
      }).then(function (data) {
        return console.log("jlog14", data);
      });
    };

    _this.getSmoothnessScore = function () {
      var totalSec = _this.player.duration();

      rebufferPercentage = Math.round(rebufferTime / totalSec / 10);

      _video.default.log("totalSec is", totalSec, " rebufferPercentage is ", rebufferPercentage, " rebufferTime is ", rebufferTime);

      var score1 = 100 / (1 + Math.sqrt(1 + Math.pow(rebufferCount / 2, 2)));
      var score2 = Math.exp(-10 * (rebufferTime / totalSec / 1000)) * 100;
      var result = Math.round((score1 + score2) / 2);

      _video.default.log("score1", score1, "score2", score2, 'getSmoothnessScore', result);

      rebufferTime = 0;
      rebufferCount = 0;
      return result;
    };

    _this.player.ready(function () {
      _video.default.log('ready time: ', Date.now());

      var tech = _this.player.tech();

      console.log("jlog21", tech);

      if (tech) {
        tech.ready(function () {
          console.log("jlog22 ready", tech.name());
        });
      }
    });

    _this.player.on('loadedmetadata', function (data) {
      _video.default.log('loadedmetadata time', Date.now());
    });

    _this.player.on('loadeddata', function (data) {
      _video.default.log('loadeddata time', Date.now());
    });

    _this.player.on('sourceset', function () {
      _video.default.log('sourceset time', Date.now());
    });

    _this.player.on('loadstart', function () {
      _video.default.log('loadstart time', Date.now());
    });

    _this.player.on('waiting', function () {
      var tnow = Date.now();

      _video.default.log('waiting', tnow);

      if (!waiting) {
        waiting = true;
        rebufferCount++;
        waitingStartTime = tnow;
      }
    });

    _this.player.on('playing', function () {
      var tnow = Date.now();

      _video.default.log('playing', tnow);

      if (waiting) {
        waiting = false;
        var diff = tnow - waitingStartTime;

        _video.default.log('waitingStartTime is ', waitingStartTime, " difference is ", diff);

        rebufferTime += diff;
      }

      if (playbackStatus == 0) {
        playbackStatus = 1;
        var firstPlayingTime = Date.now(),
            startupTime = firstPlayingTime - firstPlayTime;
        console.log("firstPlayingTime == " + firstPlayingTime);
        console.log("firstPlayTime == " + firstPlayTime);

        _video.default.log('startupTime time', startupTime);

        var data = {
          "video_id": _this.options.video_id,
          "user_id": _this.options.user_id,
          "partner_id": _this.options.partner_id,
          "video_start_time": startupTime
        };

        console.log('_this == ');
        console.log(_this);
        console.log('_this.options == ');
        console.log(_this.options);

        _this.ingestMetricsPlaybackSuccess(data);
      }
    }); //TODO: maybe first play? or merge
    // this.player.on('playing', () => {
    //   if (playbackStatus == 0) {
    //     playbackStatus = 1;
    //     var firstPlayingTime = Date.now(), startupTime = firstPlayingTime - firstPlayTime;
    //     videojs.log('startupTime time', startupTime);
    //     var data = {
    //       "video_id": this.options.video_id,
    //       "user_id": this.options.user_id,
    //       "partner_id": this.options.partner_id,
    //       "video_start_time": startupTime
    //     };
    //     this.ingestMetricsPlaybackSuccess(data);
    //   }
    // });


    _this.player.on('error', function () {
      _video.default.log('error time', Date.now());

      playbackStatus = -1;

      var err = _this.player.error();

      _video.default.log('there is an error! ', err);

      var data = {
        "video_id": _this.options.video_id,
        "user_id": _this.options.user_id,
        "partner_id": _this.options.partner_id,
        "error": err
      };

      _this.ingestMetricsPlaybackSuccess(data);
    });

    _this.player.on('ended', function () {
      _video.default.log('video ended');

      var smoothnessScore = _this.getSmoothnessScore();

      var data = {
        "video_id": _this.options.video_id,
        "user_id": _this.options.user_id,
        "partner_id": _this.options.partner_id,
        "rebufferCount": rebufferCount,
        "rebufferPercentage": rebufferPercentage,
        "smoothnessScore": smoothnessScore
      };

      _this.ingestRebufferingData(data);
    });

    _this.player.on('close', function () {
      closeTime = Date.now();

      _video.default.log('exitTime', exitTime);

      if (playbackStatus == 0) {
        var exitTime = closeTime - readyTime;
        var data = {
          "video_id": _this.options.video_id,
          "user_id": _this.options.user_id,
          "partner_id": _this.options.partner_id,
          "viewer_exit_time": exitTime
        };

        _this.ingestMetricsPlaybackSuccess(data);
      } // alert('closed');

    });

    return _this;
  }

  return ThetaVideoMetrics;
}(Plugin); // Define default values for the plugin's `state` object here.


ThetaVideoMetrics.defaultState = {}; // Include the version number.

_video.default.registerPlugin('thetaVideoMetrics', ThetaVideoMetrics);

var _default = ThetaVideoMetrics;
exports.default = _default;
module.exports = exports.default;
